import React, { useState } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import blankimg from '../../images/Union.png'
import './home.css'
import home_logo_list from '../../images/home_logo_list.jpeg';
import first from '../../images/carosualsImage/first.jpg'
import second from '../../images/carosualsImage/second.jpg'
import third from '../../images/carosualsImage/third.jpg'
import fourth from '../../images/carosualsImage/poster4-03.jpg'
import test from '../../images/carosualsImage/test.jpeg'
import {useHistory, Link} from 'react-router-dom';
import stamp_paper_home from '../../images/stamp_paper_home.png';
import Franking_home from '../../images/Franking_home.jpg'
import notary_home from '../../images/notary_home.jpeg'
import digital_signature from '../../images/digital_signature.jpg'
const Home =()=>{
    const history=useHistory()
    const [allservices,setallservices]=useState([
        {
            label:'Stamp Paper',
            impgepath:stamp_paper_home
        },
        {
            label:'E-Stamp Paper',
            impgepath:stamp_paper_home
        },
        {
            label:'Franking',
            impgepath:Franking_home
        },
        {
            label:'E-Franking',
            impgepath:Franking_home
        },
        {
            label:'Notary',
            impgepath:notary_home
        },
        {
            label:'E-Sign',
            impgepath:digital_signature
        }, 
    ])
    return(
        <div>
            <div style={{
                padding:10,
                borderRadius:50
            }}>
                <Carousel wrap={false}>
                    <Carousel.Item>
                    <img
                    className="d-block w-100"
                        style={{
                            height:400,
                        }}
                        src={first}
                        alt="First slide"
                        onClick={()=>{
                             history.push('/login') }} />
                    </Carousel.Item>
                    <Carousel.Item>
                    <img
                    className="d-block w-100"
                    style={{
                        height:400,
                        
                    }}
                        src={second}
                        alt="Second slide"
                   
                        onClick={()=>{
                             history.push('/login') }} />
                
                    </Carousel.Item>
                    <Carousel.Item>
                    <img
                    className="d-block w-100"
                    style={{
                        height:400,

                    }}
                        src={third}
                        alt="Third slide"
                        onClick={()=>{
                             history.push('/login') }} />
                    </Carousel.Item>
                    <Carousel.Item>
                    <img
                    className="d-block w-100"
                    style={{
                        height:400,

                    }}
                        src={fourth}
                        alt="Third slide"
                        onClick={()=>{
                             history.push('/login') }} />
                    </Carousel.Item>
                </Carousel>
            </div> 
            <div style={{
                textAlign:'center'
            }}>
                 <h3 style={{fontWeight:'bold'}}>OUR SERVICES</h3>   
            </div>
            <div  className="grid-container">
                {allservices.map((val, i)=>{
                    return(
                        <div key={i} onClick={()=>{
                            // history.push('/login')
                            history.push({
                                pathname: '/raiserequests',
                                search: '',
                                state: { serviceName: val.label }
                            })

                        }} style={{
                            cursor:'pointer',
                            position:'relative'
                        }} className="grid-item">
                            <img style={{
                                width:'100%',
                                height:'100%',
                                objectFit:'contain'
                            }} src={val.impgepath}/>
                            <div style={{
                                position:'absolute',
                                bottom: 8,
                                width: '100%'
                            }}>
                                <h3 style={{
                                    color:'azure',
                                    fontWeight:'bold'
                                }}>{val.label}</h3>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
export default Home;